export const environment = {
  arq: {
    // ========== CORE CONFIGURATION ==========
    env: 'PRE',
    production: false,
    appName: 'APA',
    exposure: 'INTERNET',
    directoryActive: 'PRE',
    remoteConfig: {
      // Ejemplos típicos (placeholders que resolverá substituteEnvVariables con ENV_CONFIG)
      featureFlags: {
        maintenanceMode: false
      }
    },
    // ========== AUTHENTICATION ==========
    authentication: {
      refreshable: true,
      refreshTypes: ['byUserActivity', 'byCustomAction'],
      refreshTime: 600000,
      refreshTimeByUserActivity: 300000,
      refreshTimeByCustomAction: 600000,
      refreshTimeNoRefreshable: 0,
      guard: {
        deniedRoute: '/access-denied',
        postLoginRoutes:{
            'default':{
              login: '/protected',
              fail: '/failed-auth',
              logout: '/home',
            },
            'home':{
              login: '/test/auth',
              fail: '/failed-auth',
              logout: '/home',
            },
            'test/auth':{
              login: '/home',
              fail: '/failed-auth',
              logout: '/home',
            }
        }
      }
    },
    // ========== MESSAGING ==========
    messaging: {
      websocketBaseUrl: 'wss://websocket-microapa-domain-demo.apps.m3des-sca-002-k01.m3cpocp01.dev.cloud.sca'
    },
    // ========== SECURITY ==========
    security: {
      credentials: {
        clientId: '1f28fc3c-363e-4e25-b2ef-def8349e8c85',
      }
    },
    // ========== TRACES ==========
    traces: {
      logLevel: 'debug'
    },
    
  }
};
